export default "__VITE_ASSET__DSKB0vc$__"